import { apiSlice } from 'store/slices/api/api-slice';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        cardDelete: builder.mutation({
            query: (id: string) => ({
                url: `/card/card/` + id,
                method: 'DELETE',
                header: {},
            }),
        }),
    }),
});

export const { useCardDeleteMutation } = importTradeDataApiSlice;
